// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSpinner_wrapper__+lQyv","spinner":"LoadingSpinner_spinner__Tk4dF","rotate":"LoadingSpinner_rotate__uiJwb"};